import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import {
  getImageUrl,
  ImageLoader,
  isImage,
  LoadingButton,
  NotificationTypeEnum,
  useDialog,
  useNotification,
} from '@prismamedia/one-components';
import { convertFromRaw } from 'draft-js';
import { FC, useState } from 'react';
import {
  BrandKey,
  ContentType,
} from '../../../__generated__/queries-newsletter';
import { ArticleState } from '../reducer';
import { useSendNLFlash } from './nlFlash.newsletter.graphql';

export const NLFlashDialog: FC<{ article: ArticleState }> = ({ article }) => {
  const { closeDialog } = useDialog();
  const [subject, setSubject] = useState('');
  const [loading, setLoading] = useState(false);
  const { pushNotification } = useNotification();
  const sendNLFlash = useSendNLFlash();

  const articleLead = article.lead
    ? convertFromRaw(article.lead).getPlainText()
    : '';

  const firstImage = article.medias?.find((media) => isImage(media));
  const imageUrl = firstImage && getImageUrl(firstImage);

  const onValidate = async () => {
    if (!imageUrl) return;

    if (!article.canonical) {
      pushNotification({
        message: 'URL missing for this article',
        type: NotificationTypeEnum.error,
      });
      return;
    }

    setLoading(true);
    try {
      await sendNLFlash({
        variables: {
          brandKey: (article.brandKey as string) as BrandKey,
          subject,
          teaser: articleLead,
          img: imageUrl,
          imgAlt: article.title,
          title: article.title,
          contentUrl: article.canonical,
          uuid: article.id,
          resource: ContentType.ARTICLE,
        },
      });
      pushNotification({
        message: 'Newsletter flash envoyé',
        type: NotificationTypeEnum.success,
      });
      closeDialog();
    } catch (error) {
      pushNotification({
        message: (error as Error).message,
        type: NotificationTypeEnum.error,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <DialogTitle>Newsletter Flash</DialogTitle>
      <DialogContent sx={{ width: 600 }}>
        <TextField
          multiline
          required
          fullWidth
          label="Objet"
          value={subject}
          onChange={({ target }) => setSubject(target.value)}
          sx={{ mt: 1 }}
        />
        <TextField
          multiline
          required
          fullWidth
          label="Pré-header"
          disabled
          value={articleLead}
          onChange={({ target }) => setSubject(target.value)}
          sx={{ my: 2 }}
        />
        <ImageLoader
          src={imageUrl}
          loaderSize={450 / 4}
          sx={{ minHeight: 200, borderRadius: 1, overflow: 'hidden' }}
        />
        {!imageUrl && (
          <Typography color="error" sx={{ textAlign: 'center' }}>
            Une image est requise sur l'article
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => closeDialog()}>
          Annuler
        </Button>
        <LoadingButton
          loading={loading}
          variant="contained"
          disabled={!subject || !imageUrl}
          onClick={() => onValidate()}
        >
          Envoyer
        </LoadingButton>
      </DialogActions>
    </>
  );
};
